<template>
  <div>
    <div id="articlesLoadingBox" v-if="isLoading">
      <img class="d-none d-md-block mb-4" style="opacity:0.6;"
        src="/wp-content/themes/understrap-child/fidelio-templates/images/articlesPlaceholder.svg" alt="">
      <img class="d-md-none mb-4" style="opacity:0.6;"
        src="/wp-content/themes/understrap-child/fidelio-templates/images/articlesPlaceholderMobile.svg"
        alt="">
    </div>

    <div v-if="articles && articles.length" class="bg-white mb-4 px-5 py-1 rounded-corners-10">
      <div class="text-primary my-3">
        <h5 class="font-weight-bolder" style="font-size: x-large;">{{ $t('CategoryPage.articlesOnTopic') }}</h5>
      </div>
      <div class="splide articleSplide newFeatureSlider" aria-label="Slider for Articles on the topic">
        <div class="sands-article-vueslidercontainer splide__track">
          <div class="splide__list">
            <div class="sands-article-detail mb-3 mt-3 mt-lg-2 splide__slide"
              v-for="(article, i) in articles" :key="i">
              <div>
                <div class="p-0 align-items-stretch">
                  <div>
                    <a :href="constructCourseURL(article)" class="cursorPointer">
                      <img v-if="article.teaserImage && article.teaserImage.xxx" itemprop="image" loading="lazy"
                        class="card-img" :src="article.teaserImage.xxx">
                    </a>
                    <div class="card border-0"></div>
                  </div>
                </div>
                <div class="pb-1 pt-3 d-flex flex-column h-100">
                  <a :href="constructCourseURL(article)" class="cursorPointer">
                    <div>
                      <h4 v-if="article.name" class="text-break" style="font-size: larger;" itemprop="headline">
                        {{ article.name }}
                      </h4>
                    </div>
                    <p v-if="article.abstract" class="article-excerpt mt-2" itemprop="abstract">
                      {{ truncatedAbstract(article.abstract, 70) }}
                    </p>
                    <div class="author-info">
                      <cite v-if="article.authors[0].forename && article.authors[0].surname" itemprop="authors"
                        class="text-secondary">
                        <span>
                          <span> {{ article.authors[0].forename }} {{ article.authors[0].surname }}<span></span></span>
                        </span>
                      </cite>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Splide from '@splidejs/splide';
import CONCORD_QUERIES from "../../services/concord_queries.js";
import helperFunction from "../../services/helperfunctions.js";
import { watch } from 'vue';
import useElementVisible  from "../../services/elementVisibilityService.js" ;
import axios_queries from '../../services/axios_queries.js';

export default {
  name: "categoryArticles",
  props: {
    settingsPerm: Object,
  },
  data() {
    return {
      isLoading: false,
      articles: false,
      loadMorePossible: true,
      isDevMioActive: false,
      currentPage: 1,
      metaCount: 0,
      splide: null,
      firstTimeInViewport: true,
    }
  },


  created() {
    this.isLoading = true;
    setTimeout(() => {
    this.box1Ref = document.getElementById('articlesLoadingBox');

    if (this.box1Ref) {
            const isVisible  = useElementVisible(this.box1Ref);
            if (isVisible && isVisible.value && isVisible.value == true) {
              this.firstTimeInViewport = false;
              this.loadInitialData();
            }

        watch(isVisible, (newValue) => {
        if (this.firstTimeInViewport && isVisible && newValue === true) {
            this.firstTimeInViewport = false;
            this.loadInitialData();
        }
        });
    }
      this.emitter.on('TutotialsProcessed', () => {
        this.firstTimeInViewport = false;
        this.loadInitialData();
      });
    }, 500);
    if (this.settingsPerm && this.settingsPerm.isDevMioActive) {
      this.isDevMioActive = this.settingsPerm.isDevMioActive;
    }
  },
  
  methods: {

    loadInitialData() {
      
      let catArticlesLoadingParams = {
        page: 1,
        pagesize: 12,
        querystring: this.settingsPerm.cat,
        transientKey: this.settingsPerm.cat+'-cat-depending-articles-vue',
        query:  "cat-depending-articles-vue",
        url: this.settingsPerm.ajaxUrl+'/wp-content/uploads/catpages/'+this.settingsPerm.cat+'-cat-depending-articles-vue.json'
      };
      axios_queries.loadPublicData(catArticlesLoadingParams).then((concordData) => {
          if (concordData && concordData != null && concordData != undefined && concordData != '') {
                if (concordData.advancedSearch && concordData.advancedSearch.articles && concordData.advancedSearch.articles.Articles && concordData.advancedSearch.articles.Articles.length) {
                  this.displayArticles(concordData.advancedSearch.articles.Articles);
                   this.emitter.emit('articlesProcessed', true);
              }else{
                this.isLoading = false;
                this.emitter.emit('articlesProcessed', true);
              }
          }else{
            this.isLoading = false;
            this.emitter.emit('articlesProcessed', true);
          }
      })
    },

    displayArticles(articles){
      this.articles = articles;
      this.isLoading = false;
      this.mount_splide();
    },
    
    async loadMoreData() {
      // Make an API call to fetch more data
      const nextPage = this.currentPage + 1;
      let variablesForQuery = {
        page: nextPage,
        pagesize: 12,
        querystring: this.settingsPerm.cat,
        years: [],
        brandIDs: [],
        categoryIDs: []
      };
      let graphqlQuery = CONCORD_QUERIES.CAT_SPECIFIC_ARTICLE;
      let concordData = await axios_queries.getMoreData(graphqlQuery,variablesForQuery);
        if (concordData && concordData.advancedSearch && concordData.advancedSearch.articles && concordData.advancedSearch.articles.Articles && concordData.advancedSearch.articles.Articles.length) {
          const newarticles = concordData.advancedSearch.articles.Articles;
          // console.log('New articles',newarticles);
          this.articles = [...this.articles, ...newarticles];
          // console.log('articles',this.articles);
          this.isLoading = false;
          this.currentPage = nextPage;
          this.mount_splide();
        }

    },

    addMovedEventListener() {
            this.splide.on('moved', (newIndex) => {
                const lastCardIndex = newIndex + this.splide.options.perPage;
                if (lastCardIndex === this.articles.length - 2 && this.articles.length > this.metaCount) {
                    this.loadMoreData();
                }
            });
        },



    appendCourseSlugToCurrentURL(concordObject) {
      const currentURL = window.location.href;
      const updatedURL = currentURL + '/' + concordObject;
      window.location.href = updatedURL;
    },
    constructCourseURL(concordObject) {
      return helperFunction.sandsConstructRealUrl(concordObject);
    },

    truncatedAbstract(text, length) {
      if (text.length <= length) {
        return text;
      } else {
        return text.substring(0, length) + '...';
      }
    },

    mount_splide: function () {
      let thiz = this;
      setTimeout(function () {
        if (!thiz.splide) {
          thiz.splide = new Splide('.articleSplide', {
            classes: {
              prev: 'splide__arrow--prev xx',
              next: 'splide__arrow--next xxx',
              arrow: 'splide__arrow xxxx',
            },
            perPage: 4,
            perMove: 1,
            rewindByDrag: true,
            gap: '1rem',
            breakpoints: {
              1024: {
                perPage: 4,
                padding: {
                  right: '0rem',
                  left: '0rem',
                }
              },
              991: {
                perPage: 2,
                padding: {
                  right: '0rem',
                  left: '0rem',
                }
              },
              767: {
                perPage: 1,
                padding: {
                  right: '0rem',
                  left: '0rem',
                }
              },
            },
            rewind: false,
            pagination: false,
            padding: {
              right: '0rem',
              left: '0rem',
            }
          });
          thiz.splide.mount();
          thiz.addMovedEventListener(); // Add event listener
        } else {
          thiz.splide.refresh(); // Refresh the existing Splide instance
        }
      }, 100);
    },

  },

};
</script>

<style>
.author-info {
  display: flex;
  flex-direction: column;
}
</style> 